"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = require("@chakra-ui/layout");
var _react = require("@chakra-ui/react");
var _jsxRuntime = require("react/jsx-runtime");
const FileContextMenu = props => {
  const bg = (0, _react.useColorModeValue)('white', 'gray.700');
  const itemBgColor = (0, _react.useColorModeValue)('blue.100', 'blue.400');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
      maxW: "3xs",
      borderWidth: "1px",
      borderRadius: "lg",
      overflow: "hidden",
      bg: bg,
      onContextMenu: e => e.preventDefault(),
      children: props.items.map(({
        content,
        _type,
        onItemClick,
        ...props
      }, key) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, {
        mb: 1,
        mt: 1,
        children: [_type === 'ITEM' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Button, {
          bg: 'transparent',
          borderRadius: 0,
          w: "full",
          _focus: {
            boxShadow: 'none !important'
          },
          _hover: {
            bg: itemBgColor
          },
          fontWeight: "initial",
          fontSize: "sm",
          justifyContent: "flex-start",
          onClick: onItemClick,
          children: content
        }), _type === 'DIVIDER' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Divider, {
          ...props
        })]
      }, key))
    })
  });
};
var _default = FileContextMenu;
exports.default = _default;